import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SftpCustomValidators } from '@app/sftp-mgmt/util/sftp-validators';
import { Client } from '@app/core/models/client';
import { ActionService } from '@app/cx-builder/message-builder/services/action.service';
import { ClientHeaderComponent } from '../../../shared/client-header/client-header.component';
import { ErrorDisplayComponent } from '../../../shared/error-display/error-display.component';
import { SftpKeyUploadInstructionsComponent } from '../sftp-key-upload-instructions/sftp-key-upload-instructions.component';

@Component({
    selector: 'rn-sftp-new-key',
    templateUrl: './sftp-new-key.component.html',
    styleUrls: ['./sftp-new-key.component.scss'],
    standalone: true,
    imports: [ClientHeaderComponent, FormsModule, ReactiveFormsModule, ErrorDisplayComponent, SftpKeyUploadInstructionsComponent]
})
export class SftpNewKeyComponent implements OnInit {
  @Input() client: Client;
  @Output() onSaveClicked = new EventEmitter<string>();
  @Output() onCancelClicked = new EventEmitter<any>();

  sshKeyFieldPlaceholder: string = `---- BEGIN SSH2 PUBLIC KEY ----\nComment: "2048-bit RSA, converted by username@computername.local fro"\nXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX\nXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX\nXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX\nXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX\nXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX\nXXXXXXXXXXXXXXXXXXXXXX\n---- END SSH2 PUBLIC KEY ----`
  sshKeyCtl = new UntypedFormControl(null, [Validators.required, SftpCustomValidators.isValidSSH2FormatValidator]);

  // ActionService preservation pattern for ErrorDisplayComponent
  get customErrorMessageProvider() {
    return () => ({
      required: 'This field is required.',
      invalidSSH2Key: 'Invalid SSH key format'
    });
  }

  constructor(private actionService: ActionService) { }

  ngOnInit(): void {
    this.reset();
  }

  saveKey(): void {
    if (this.sshKeyCtl.invalid) {
      return;
    }

    this.onSaveClicked.emit(this.sshKeyCtl.value);
  }

  reset() {
    this.sshKeyCtl.reset(null);
  }

  handleCancelClicked() {
    this.reset();
    this.onCancelClicked.emit();
  }
}
